export * from "./getCSSCustomProperty";
